module.exports = __webpack_public_path__ + "img/mastercard.32a5aada.svg";